<div >
  <div id="form">
    <form [formGroup]="formGroup" autocomplete="off">
      <div>
        <h3 class="section-name">
          {{'AdminUsersManagement.CreateEditUser.ContactInformationTitle' | translate}}
        </h3>

        <div class="flex justify-content-end">
          <p-button styleClass="p-button-sm" (click)="CreateMock()" label="Generar datos">
          </p-button>
        </div>

        <div class="p-fluid formgrid grid align-items-start align-content-start">
          <div class="field col-12 md:col-6 lg:col-4 xl:col-3">
            <label for="profileType">
              {{'AdminUsersManagement.CreateEditUser.ProfileLabel' | translate}}
              <span class="mandatory-field">*</span>
            </label>
            <p-dropdown inputId="profileType" formControlName="profileType" [options]="profileTypeOptions" optionLabel="label" optionValue="value"
              placeholder="{{'AdminUsersManagement.CreateEditUser.SelectProfilePlaceholder' | translate}}" [autoDisplayFirst]="false" class="custom-dropdown bg-form"></p-dropdown>
            <small *ngIf="submit && formGroup.controls['profileType'].invalid" class="p-error">{{getErrorMessage('profileType')}}</small>
          </div>

          <!-- Se muestra en esta posicion en caso de que se desea hacer un mock de importador, para probar la creación de usuarios con perfil importador sin necesidad de tener el servicio de importadores listo -->
          <div class="field col-12 md:col-6 lg:col-4 xl:col-3" *ngIf="mockImporter">
            <label for="companyName">
              {{'AdminUsersManagement.CreateEditUser.CompanyNameLabel' | translate}}
            </label>
            <input pInputText id="companyName" formControlName="companyName" type="text"
              placeholder="{{'AdminUsersManagement.CreateEditUser.ExporterCompanyPlaceholder' | translate}}" class="custom-input bg-form"/>
            <small *ngIf="submit && formGroup.controls['companyName'].invalid" class="p-error">{{getErrorMessage('companyName')}}</small>
          </div>

          <div class="field col-12 md:col-6 lg:col-4 xl:col-3">
            <label for="contactName">
              {{'AdminUsersManagement.CreateEditUser.ContactNameLabel' | translate}}
              <span class="mandatory-field">*</span>
            </label>
            <input id="contactName" formControlName="contactName" type="text" required pInputText
              placeholder="{{'AdminUsersManagement.CreateEditUser.ContactNameLabel' | translate}}" class="custom-input bg-form"/>
            <small *ngIf="submit && formGroup.controls['contactName'].invalid" class="p-error">{{getErrorMessage('contactName')}}</small>
          </div>

          <div class="field col-12 md:col-6 lg:col-4 xl:col-3">
            <label for="contactLastName">
              {{'AdminUsersManagement.CreateEditUser.ContactLastNameLabel' | translate}}
              <span class="mandatory-field">*</span>
            </label>
            <input id="contactLastName" formControlName="contactLastName" type="text" required pInputText
              placeholder="{{'AdminUsersManagement.CreateEditUser.ContactLastNameLabel' | translate}}" class="custom-input bg-form"/>
            <small *ngIf="submit && formGroup.controls['contactLastName'].invalid" class="p-error">{{getErrorMessage('contactLastName')}}</small>
          </div>

          <div class="field col-12 md:col-6 lg:col-4 xl:col-3">
            <label for="contactEmail">
              {{'AdminUsersManagement.CreateEditUser.EmailLabel' | translate}}
              <span class="mandatory-field">*</span>
            </label>
            <input id="contactEmail" formControlName="contactEmail" type="text" pInputText
              placeholder="{{'AdminUsersManagement.CreateEditUser.EmailLabel' | translate}}" class="custom-input bg-form"/>
            <small *ngIf="submit && formGroup.controls['contactEmail'].invalid" class="p-error">{{getErrorMessage('contactEmail')}}</small>
          </div>

          <div class="field col-12 md:col-6 lg:col-4 xl:col-3">
            <label for="country">
              {{'AdminUsersManagement.CreateEditUser.CountryLabel' | translate}}
              <span class="mandatory-field">*</span>
            </label>
            <p-dropdown id="contactCountry"
              formControlName="contactCountryId"
              [options]="countries"
              optionValue="id"
              optionLabel="name"
              [filter]="true"
              filterBy="name"
              [showClear]="true"
              placeholder="{{'AdminUsersManagement.CreateEditUser.SelectCountryPlaceholder' | translate}}"
              class="custom-dropdown bg-form">
            </p-dropdown>
            <small *ngIf="submit && formGroup.controls['contactCountryId'].invalid" class="p-error">{{getErrorMessage('contactCountryId')}}</small>
          </div>

          <div class="field col-12 md:col-6 lg:col-4 xl:col-3">
            <label for="contactCity">
              {{'AdminUsersManagement.CreateEditUser.CityLabel' | translate}}
            </label>
            <input id="contactCity" formControlName="contactCity" type="text"  pInputText
              placeholder="{{'AdminUsersManagement.CreateEditUser.CityLabel' | translate}}" class="custom-input bg-form"/>
            <small *ngIf="submit && formGroup.controls['contactCity'].invalid" class="p-error">{{getErrorMessage('contactCity')}}</small>
          </div>

          <div class="field col-12 md:col-6 lg:col-4 xl:col-3">
            <label for="contactAddress">
              {{'AdminUsersManagement.CreateEditUser.AddressLabel' | translate}}
            </label>
            <input id="contactAddress" formControlName="contactAddress" type="text" pInputText
              placeholder="{{'AdminUsersManagement.CreateEditUser.AddressLabel' | translate}}" class="custom-input bg-form"/>
            <small *ngIf="submit && formGroup.controls['contactAddress'].invalid" class="p-error">{{getErrorMessage('contactAddress')}}</small>
          </div>

          <div class="field col-12 md:col-6 lg:col-4 xl:col-3">
            <label for="contactPhone">
              {{'AdminUsersManagement.CreateEditUser.PhoneLabel' | translate}}
            </label>
            <input id="contactPhone" formControlName="contactPhone" type="text" pInputText
              placeholder="{{'AdminUsersManagement.CreateEditUser.PhoneLabel' | translate}}" class="custom-input bg-form"/>
          </div>

        </div>
      </div>

      <p-divider/>

      <div>
        <h3 class="section-name">
          {{'AdminUsersManagement.CreateEditUser.CompanyInformationTitle' | translate}}
        </h3>

        <div class="p-fluid formgrid grid align-items-start align-content-start">
          <div class="field col-12 md:col-6 lg:col-4 xl:col-3">
            <label for="vat">
              {{'AdminUsersManagement.CreateEditUser.VatIdLabel' | translate}}
            </label>
            <input pInputText id="vat" formControlName="vat" type="text"
              placeholder="{{'AdminUsersManagement.CreateEditUser.VatPlaceholder' | translate}}" class="custom-input bg-form"/>
            <small *ngIf="submit && formGroup.controls['vat'].invalid" class="p-error">{{getErrorMessage('vat')}}</small>
          </div>

          <div class="field col-12 md:col-6 lg:col-4 xl:col-3" *ngIf="!mockImporter">
            <label for="companyName">
              {{'AdminUsersManagement.CreateEditUser.CompanyNameLabel' | translate}}
            </label>
            <input pInputText id="companyName" formControlName="companyName" type="text"
              placeholder="{{'AdminUsersManagement.CreateEditUser.ExporterCompanyPlaceholder' | translate}}" class="custom-input bg-form"/>
            <small *ngIf="submit && formGroup.controls['companyName'].invalid" class="p-error">{{getErrorMessage('companyName')}}</small>
          </div>

          <div class="field col-12 md:col-6 lg:col-4 xl:col-3">
            <label for="sagCode">
              {{'AdminUsersManagement.CreateEditUser.SagLabel' | translate}}
            </label>
            <p-inputNumber id="sagCode" formControlName="sagCode" [useGrouping]="false" [maxlength]="9"
              placeholder="{{'AdminUsersManagement.CreateEditUser.SagCodePlaceholder' | translate}}" class="custom-input-number bg-form"/>
            <small *ngIf="submit && formGroup.controls['sagCode'].invalid" class="p-error">{{getErrorMessage('sagCode')}}</small>
          </div>

          <div class="field col-12 md:col-6 lg:col-4 xl:col-3">
            <label for="legalRepresentativeName">
              {{'AdminUsersManagement.CreateEditUser.LegalRepresentativeNameLabel' | translate}}
            </label>
            <input pInputText id="legalRepresentativeName" formControlName="legalRepresentativeName" type="text"
              placeholder="{{'AdminUsersManagement.CreateEditUser.LegalRepresentativeNamePlaceholder' | translate}}" class="custom-input bg-form"/>
            <small *ngIf="submit && formGroup.controls['legalRepresentativeName'].invalid" class="p-error">{{getErrorMessage('legalRepresentativeName')}}</small>
          </div>

          <div class="field col-12 md:col-6 lg:col-4 xl:col-3">
            <label for="legalRepresentativeNumber">
              {{'AdminUsersManagement.CreateEditUser.LegalRepresentativeIdLabel' | translate}}
            </label>
            <input
              pInputText
              id="legalRepresentativeNumber"
              formControlName="legalRepresentativeNumber"
              type="text"
              autocomplete="off"
              placeholder="{{'AdminUsersManagement.CreateEditUser.LegalRepresentativeIdPlaceholder' | translate}}"
              class="custom-input bg-form"/>
            <small *ngIf="submit && formGroup.controls['legalRepresentativeNumber'].invalid" class="p-error">{{getErrorMessage('legalRepresentativeNumber')}}</small>
          </div>
          <input type="text" autocomplete="username" style="display:none">
          <div class="field col-12 md:col-6 lg:col-4 xl:col-3">
              <label for="password" class="pr-2">
                {{'AdminUsersManagement.CreateEditUser.PasswordLabel' | translate}}
              </label>
              <app-password-custom-field
                formControlName="password"
                [minlength]="8"
                [class]="'custom-input bg-form w-full'"
                [showRequirements]="true"
              ></app-password-custom-field>
              <small *ngIf="submit && formGroup.controls['password'].invalid" class="p-error">{{getErrorMessage('password')}}</small>
          </div>

          <div class="field col-6 md:col-offset-6 md:col-3 lg:col-offset-8 lg:col-2 mt-4">
            <p-button
              label="{{'AdminUsersManagement.Messages.CancelButton' | translate}}"
              (onClick)="cancel()" [loading]="loading" styleClass="p-button-outlined"
              class="custom-text-button"/>
          </div>
          <div class="field col-6 md:col-3 lg:col-2 mt-4">
            <p-button [loading]="loading"
              label="{{'AdminUsersManagement.Messages.SaveButton' | translate}}"
              (onClick)="save()"
              class="custom-text-button"/>
          </div>
        </div>
      </div>

    </form>
  </div>
</div>


